// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"e7dd6e50","242":"85c847b8","418":"b81da305","529":"4718f80b","537":"8d6d6cb0","584":"4aa5a865","680":"882e515b","702":"9349f7c6","886":"a681dd8d","930":"4718f80b"}[chunkId] + ".chunk.css";
};